import { render } from "./search-filter-additional-quota-requests.vue?vue&type=template&id=2d9e0966"
import script from "./search-filter-additional-quota-requests.vue?vue&type=script&lang=js"
export * from "./search-filter-additional-quota-requests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__